import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { IntegrationService } from '../services/integration.service';
import { Integration } from '../services/models/integration.model';

@Component({
  selector: 'app-integrations',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.css'
})
export class IntegrationsComponent implements OnInit {
  integrations: Integration[] = [];
  isLoading: boolean = false;
  loadError: boolean = false;

  constructor(private integrationService: IntegrationService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.loadError = false;

    this.integrationService.getIntegrations().subscribe({
      next: (result) => {
        this.integrations = result ?? [];
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erro ao carregar integrações:', error);
        this.loadError = true;
        this.isLoading = false;
      }
    });
  }

  trackByKey(index: number, item: Integration): string {
    return item.key;
  }
}
